import { Navigate, Outlet } from 'react-router';
import { usePlatformConfig } from '@/services/queries';

/** Experiences kill switch: with activities disabled on the platform, every /activities URL goes home. */
export function ActivitiesGuard() {
  const { data: config } = usePlatformConfig();
  if (config && !config.activitiesEnabled) return <Navigate to="/" replace />;
  return <Outlet />;
}
